import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';
import { core } from '@mgmresorts/vega-tokens';
import ReactMarkdown from 'react-markdown';
import { css } from 'styled-components';

import { convertFontWeight } from '../../utils/vegaTokenHelpers';

export const StyledContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: ${theme.semantic.SpaceComponentM}px;
  background: ${theme.semantic.ErrorSubtle};
  gap: ${theme.semantic.SpaceComponentS}px;
  width: 100%;
  min-height: ${theme.semantic.SizeComponentL}px;
  margin-bottom: ${theme.semantic.SpaceComponentL}px;

  /* Core/errorRed */

  &.error {
    border: 1px solid ${theme.semantic.ErrorDefault};
    border-radius: ${theme.semantic.BorderRadiusComponentM}px;

    svg {
      fill: ${theme.semantic.FgDefault};
      path {
        fill: ${theme.semantic.FgDefault};
      }
    }

    a span {
      color: ${theme.semantic.FgGhost} !important;
      font-weight: ${convertFontWeight(core.Fontweight600)};
    }
  }

  &.info {
    border: 1px solid ${theme.semantic.InteractionDefault};
    background-color: ${theme.core.InteratctionSubtle};

    svg {
      fill: ${theme.semantic.InteractionDefault};
      path {
        fill: ${theme.semantic.InteractionDefault};
      }
    }
  }

  box-sizing: border-box;
  border-radius: ${theme.semantic.BorderRadiusComponentM}px;

  /* Inside Auto Layout */
  flex: none;
  flex-grow: 0;
 
  }
`}
`;

const sharedAlertTextStyles = css`
  ${({ theme }) => `
  font-weight: ${convertFontWeight(core.Fontweight400)};
  font-size: ${theme.core.FontsizeM}px;
  margin: 0;
  padding: 0;
  flex: none;
  order: 1;
  flex-grow: 0;
  line-height: ${theme.semantic.SizeComponentXs};
  word-break: break-word;
  max-width: calc(100% - 24px);
  color: ${theme.semantic.FgDefault};
  > p {
    margin: 0;
    padding: 0;
    * {
      color: ${theme.semantic.FgDefault};
    }
    }
`}
`;

export const StyledTypography = styled(Typography)`
  ${sharedAlertTextStyles}
`;

export const StyledMarkdown = styled(ReactMarkdown)`
  ${sharedAlertTextStyles}
`;

export const StyledIconWrapper = styled.div`
  ${({ theme }) => `
  width: ${theme.semantic.SizeIconS24}px;
  height: ${theme.semantic.SizeIconS24}px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0;
  `}
`;
